import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { type Option } from '@avanta/shared/components/ui/Select';
import { useFetchCenters } from '@avanta/shared/hooks/useFetchCenters';
import { getCenterOptions } from '@avanta/shared/utils/appointments';
import { type Center } from '../types/appointments';

type SpecialityOptionField = 'city' | 'backofficeCenterId';

export const useGetSpecialityOptions = (
  field: SpecialityOptionField,
  centersData?: Center[]
): Option[] => {
  const { watch } = useFormContext();
  const [specialityId, city] = watch(['specialityBooked', 'city']);
  const { data: centers } = useFetchCenters(specialityId);

  return useMemo(
    () => getCenterOptions(centersData ?? centers ?? [], city, field),
    [centersData, centers, city, field]
  );
};
